/**
 * Capitalize first char.
 * @param {string} textToFormat Text to format.
 * @returns {string}
 */
export function capitalizeFirstChar(textToFormat) {
  if (!textToFormat) {
    return textToFormat;
  }
  return textToFormat.charAt(0).toUpperCase() + textToFormat.slice(1);
}
